import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslator } from '@Localization';
import { IconButton } from '@mui/joy';
import { ReactElement } from 'react';
import { AnnotationToolType } from '../../../../../__legacy__/modules/annotation/submodules/annotationTypes/models/annotationToolType';
import { MarkingToolIcon } from '../../../../../__legacy__/modules/annotation/submodules/segmentations/components/objectsList/MarkingToolIcon';
import { S_AnnotationStatus } from '../../../../annotations/annotationStatus/S_AnnotationStatus';
import { IGroundTruth, IRectanglePrediction } from '../../../jobPredictions.model';

interface ILocateObjectInspectorProps {
  predictedRectangles: IRectanglePrediction[] | null;
  handleTogglePredictionClassId: (classId: string) => () => void;
  predictionClassIds: string[];
  threshold: number;
  groundTruth: IGroundTruth | null | undefined;
}

export const LocateObjectsInspector = ({
  predictedRectangles,
  handleTogglePredictionClassId,
  predictionClassIds,
  threshold,
  groundTruth,
}: ILocateObjectInspectorProps): ReactElement => {
  const { t } = useTranslator();

  if (!predictedRectangles) {
    return <div>{t('no_results_for_current_image')}</div>;
  }

  return (
    <>
      {predictedRectangles.map((predictedRectangle, idx) => {
        const isVisible = predictionClassIds.includes(predictedRectangle.classId);

        return (
          <div
            key={idx}
            className='attributes segmentation clickable'
          >
            <div className='icon-with-name'>
              <div className='marking-tool-icon'>
                <MarkingToolIcon
                  toolType={AnnotationToolType.POINT}
                  color={predictedRectangle.color}
                />
              </div>
              <span className='attribute'>
                {predictedRectangle.className}:{' '}
                <S_AnnotationStatus
                  text={`${
                    predictedRectangle.rectangles.filter((rectangle) => rectangle.score >= threshold).length.toString(10) || '0'
                  }${groundTruth?.predictionCounts?.[predictedRectangle.className] ? `/${groundTruth.predictionCounts[predictedRectangle.className]}` : ''}`}
                />
              </span>
            </div>
            <div className='object-list-actions'>
              <IconButton
                size='sm'
                color={isVisible ? 'primary' : 'neutral'}
                onClick={handleTogglePredictionClassId(predictedRectangle.classId)}
              >
                <FontAwesomeIcon icon={isVisible ? faEye : faEyeSlash} />
              </IconButton>
            </div>
          </div>
        );
      })}
    </>
  );
};
